import React from "react";
import { FaFacebook, FaInstagram, FaTwitter, FaEnvelope, FaPhone } from "react-icons/fa";
import './Footer.css';

const Footer = () => (
  <footer className="site-footer">
    <div className="footer-container">
      {/* Column 1: Company Info */}
      <div className="footer-column">
        <h4>Uma Switch Gear</h4>
        <p>
          High-quality powder coating services for industrial, commercial, and custom applications.
        </p>
      </div>

      {/* Column 2: Quick Links */}
      <div className="footer-column">
        <h5>Quick Links</h5>
        <ul>
          <li><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#portfolio">Portfolio</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </div>

      {/* Column 3: Contact Info */}
      <div className="footer-column">
        <h5>Contact Us</h5>
        <p><FaEnvelope className="icon" /> pradeep.kumar.ahirwar@gmail.com</p>
        <p><FaPhone className="icon" /> +91 9981914799,9752096663</p>
        <div className="social-icons">
          <a href="#"><FaFacebook /></a>
          <a href="#"><FaTwitter /></a>
          <a href="#"><FaInstagram /></a>
        </div>
      </div>
    </div>

    <div className="footer-bottom">
      <p>© 2025 Uma Switch Gear All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
